module.exports = __webpack_public_path__ + "static/media/gasIcon.ccf61980.svg";